import React from "react";
import Layout from "../layout/Layout";

export default function BannerManagement() {
  return <Layout></Layout>;
}
